import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, Teleport as _Teleport } from "vue"
import _imports_0 from '@/assets/images/arrow_left_black.svg'


const _hoisted_1 = { class: "v-card-header d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "svg align-text-bottom text-black me-1",
  height: "18",
  width: "18",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "flex-fill" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "v-card-body" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { for: "SKU" }
const _hoisted_10 = ["placeholder", "disabled"]
const _hoisted_11 = { class: "info-msg text-muted small" }
const _hoisted_12 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_13 = { for: "Name" }
const _hoisted_14 = ["placeholder", "disabled"]
const _hoisted_15 = { class: "info-msg text-muted small" }
const _hoisted_16 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_17 = { for: "BarCode" }
const _hoisted_18 = ["placeholder", "disabled"]
const _hoisted_19 = { class: "info-msg text-muted small" }
const _hoisted_20 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_21 = { for: "ProductType" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { value: 0 }
const _hoisted_24 = { value: 1 }
const _hoisted_25 = { class: "info-msg text-muted small" }
const _hoisted_26 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_27 = { for: "Categories" }
const _hoisted_28 = { class: "dropdown" }
const _hoisted_29 = {
  href: "javascript:;",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  class: "dropdown-toggle no-dropdown-symb"
}
const _hoisted_30 = { class: "dropdown-menu" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "categories d-flex flex-wrap p" }
const _hoisted_33 = {
  key: 0,
  class: "no-categ text-warning text-bold"
}
const _hoisted_34 = { class: "categ-list-elt d-flex flex-wrap" }
const _hoisted_35 = { class: "flex-fill me-2" }
const _hoisted_36 = ["title", "onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-square-fill" }, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_40 = { for: "SubCategories" }
const _hoisted_41 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_42 = {
  href: "javascript:;",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  class: "dropdown-toggle no-dropdown-symb"
}
const _hoisted_43 = { class: "dropdown-menu" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "categories d-flex flex-wrap p" }
const _hoisted_46 = {
  key: 0,
  class: "no-categ text-warning text-bold"
}
const _hoisted_47 = { class: "categ-list-elt d-flex flex-wrap" }
const _hoisted_48 = { class: "flex-fill me-2" }
const _hoisted_49 = ["title", "onClick"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-square-fill" }, null, -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_53 = { for: "BrandCode" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { value: "" }
const _hoisted_56 = ["value"]
const _hoisted_57 = { class: "info-msg text-muted small" }
const _hoisted_58 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_59 = { class: "col-md-6 d-flex flex-column justify-content-end py-md-3" }
const _hoisted_60 = { class: "form-check" }
const _hoisted_61 = {
  class: "form-check-label",
  for: "IsKeepStock"
}
const _hoisted_62 = { class: "info-msg text-muted small" }
const _hoisted_63 = { class: "col-md-6 d-flex flex-column justify-content-end py-md-3" }
const _hoisted_64 = { class: "form-check" }
const _hoisted_65 = {
  class: "form-check-label",
  for: "IsTaxable"
}
const _hoisted_66 = { class: "info-msg text-muted small" }
const _hoisted_67 = { class: "col-md-6 d-flex flex-column justify-content-end py-md-3" }
const _hoisted_68 = { class: "form-check" }
const _hoisted_69 = {
  class: "form-check-label",
  for: "AllowPurchaseOutStock"
}
const _hoisted_70 = { class: "info-msg text-muted small" }
const _hoisted_71 = { for: "ReorderQuantity" }
const _hoisted_72 = ["placeholder", "disabled"]
const _hoisted_73 = { class: "info-msg text-muted small" }
const _hoisted_74 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_75 = { for: "MinOrderQuantity" }
const _hoisted_76 = ["placeholder", "disabled"]
const _hoisted_77 = { class: "info-msg text-muted small" }
const _hoisted_78 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_79 = { for: "PurchasePrice" }
const _hoisted_80 = ["placeholder", "disabled"]
const _hoisted_81 = { class: "info-msg text-muted small" }
const _hoisted_82 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_83 = { for: "SellingPrice" }
const _hoisted_84 = ["placeholder", "disabled"]
const _hoisted_85 = { class: "info-msg text-muted small" }
const _hoisted_86 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_87 = { class: "col-md-6 form-group" }
const _hoisted_88 = { for: "DefaultSupplier" }
const _hoisted_89 = ["disabled"]
const _hoisted_90 = { value: "" }
const _hoisted_91 = ["value"]
const _hoisted_92 = { class: "info-msg py-2 text-muted small" }
const _hoisted_93 = { class: "col-md-6 form-group" }
const _hoisted_94 = { for: "DefaultTax" }
const _hoisted_95 = ["disabled"]
const _hoisted_96 = { value: "" }
const _hoisted_97 = ["value"]
const _hoisted_98 = { class: "info-msg py-2 text-muted small" }
const _hoisted_99 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_100 = { class: "col-md-6" }
const _hoisted_101 = { class: "row" }
const _hoisted_102 = { for: "UnitOfMeasuremt" }
const _hoisted_103 = ["placeholder", "disabled"]
const _hoisted_104 = { class: "info-msg text-muted small" }
const _hoisted_105 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_106 = { for: "PcePerUnit" }
const _hoisted_107 = ["placeholder", "disabled"]
const _hoisted_108 = { class: "info-msg text-muted small" }
const _hoisted_109 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_110 = { class: "col-md-6 form-group" }
const _hoisted_111 = { for: "Tags" }
const _hoisted_112 = { class: "info-msg py-2 text-muted small" }
const _hoisted_113 = { class: "col-md-12 form-group" }
const _hoisted_114 = { for: "Description" }
const _hoisted_115 = ["placeholder", "disabled"]
const _hoisted_116 = { class: "info-msg text-muted small" }
const _hoisted_117 = { class: "mx-3 my-4" }
const _hoisted_118 = { class: "mt-4" }
const _hoisted_119 = ["disabled"]
const _hoisted_120 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_barcode = _resolveComponent("barcode")!
  const _component_jw_tag_input_v2 = _resolveComponent("jw-tag-input-v2")!
  const _component_ProdCategoryModal = _resolveComponent("ProdCategoryModal")!
  const _component_ProdSubCategoryModal = _resolveComponent("ProdSubCategoryModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["vh-100 d-flex justify-content-center align-items-center", {'d-none': !_ctx.isStillLoading}])
    }, [
      _createVNode(_component_font_awesome_icon, {
        icon: ['fa', 'fa-spinner'],
        class: "fs-1"
      })
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["v-card", {'d-none': _ctx.isStillLoading}])
    }, [
      _createElementVNode("h1", _hoisted_1, [
        _createVNode(_component_RouterLink, { to: "/app/products/products/list" }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.language.new_product), 1),
        _createElementVNode("button", {
          type: "button",
          class: "btn-xs xs-primary",
          disabled: _ctx.v$.$invalid || _ctx.isSavingRecord || !_ctx.isDefaultTaxReqSet,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveNewProduct && _ctx.saveNewProduct(...args)))
        }, [
          (_ctx.isSavingRecord)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-spinner'] }),
                _createTextVNode("  ")
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-save'] }),
                _createTextVNode("  ")
              ])),
          _createTextVNode(" " + _toDisplayString(_ctx.language.save), 1)
        ], 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.SKU.$error}])
          }, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.language.sku), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "SKU",
              class: "form-control tab-press telephone-nbr",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataRecord.SKU) = $event)),
              placeholder: '(' + _ctx.language.sku_ex.toLowerCase() + ')',
              maxlength: "12",
              autocomplete: "off",
              onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectOnFocus($event))),
              disabled: _ctx.isSavingRecord
            }, null, 40, _hoisted_10), [
              [_vModelText, _ctx.dataRecord.SKU]
            ]),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.language.sku_info_msg), 1),
            (_ctx.v$.dataRecord.SKU.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.v$.dataRecord.SKU.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.Name.$error}])
          }, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.language.name), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "Name",
              class: "form-control tab-press",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataRecord.Name) = $event)),
              placeholder: '(' + _ctx.language.name.toLowerCase() + ')',
              maxlength: "50",
              autocomplete: "off",
              onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectOnFocus($event))),
              disabled: _ctx.isSavingRecord
            }, null, 40, _hoisted_14), [
              [_vModelText, _ctx.dataRecord.Name]
            ]),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.language.name_prod_info_msg), 1),
            (_ctx.v$.dataRecord.Name.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.v$.dataRecord.Name.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.BarCode.$error}])
          }, [
            _createElementVNode("label", _hoisted_17, [
              _createTextVNode(_toDisplayString(_ctx.language.barcode) + "  ", 1),
              _createElementVNode("a", {
                href: "javascript:;",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.generateBarCode(null)))
              }, "(" + _toDisplayString(_ctx.language.generate_barcode.toLowerCase()) + ")", 1)
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "BarCode",
              class: "form-control tab-press",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dataRecord.BarCode) = $event)),
              placeholder: '(' + _ctx.language.barcode_ex.toLowerCase() + ')',
              maxlength: "10",
              autocomplete: "off",
              onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectOnFocus($event))),
              disabled: _ctx.isSavingRecord,
              onKeyup: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onKeyUpRawBarcode && _ctx.onKeyUpRawBarcode(...args)))
            }, null, 40, _hoisted_18), [
              [_vModelText, _ctx.dataRecord.BarCode]
            ]),
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.language.barcode_info_msg), 1),
            (_ctx.v$.dataRecord.BarCode.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.v$.dataRecord.BarCode.$errors[0].$message), 1))
              : _createCommentVNode("", true),
            (_ctx.isBarCodeReady && _ctx.dataRecord.BarCode.length == 10)
              ? (_openBlock(), _createBlock(_component_barcode, {
                  key: 1,
                  value: _ctx.dataRecord.BarCode
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Show this if the rendering fails. ")
                  ]),
                  _: 1
                }, 8, ["value"]))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.ProductType.$error}])
          }, [
            _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.language.type), 1),
            _withDirectives(_createElementVNode("select", {
              id: "ProductType",
              class: "form-control-sel tab-press",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dataRecord.ProductType) = $event)),
              disabled: _ctx.isSavingRecord
            }, [
              _createElementVNode("option", _hoisted_23, _toDisplayString(_ctx.language.product), 1),
              _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.language.service), 1)
            ], 8, _hoisted_22), [
              [_vModelSelect, _ctx.dataRecord.ProductType]
            ]),
            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.language.product_type_info_msg), 1),
            (_ctx.v$.dataRecord.ProductType.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_ctx.v$.dataRecord.ProductType.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.Categories.$error}])
          }, [
            _createElementVNode("label", _hoisted_27, [
              _createTextVNode(_toDisplayString(_ctx.language.categories) + "  (", 1),
              _createElementVNode("span", _hoisted_28, [
                _createElementVNode("a", _hoisted_29, _toDisplayString(_ctx.language.select_category.toLowerCase()), 1),
                _createElementVNode("ul", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstCategories, (oCateg) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: oCateg.Code
                    }, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        href: "javascript:;",
                        onClick: ($event: any) => (_ctx.selectCategory(oCateg))
                      }, _toDisplayString(_ctx.getCategoryName(oCateg)), 9, _hoisted_31)
                    ]))
                  }), 128))
                ])
              ]),
              _createTextVNode(") ("),
              _createElementVNode("a", {
                href: "javascript:;",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.addCategoryElement && _ctx.addCategoryElement(...args)))
              }, _toDisplayString(_ctx.language.new_categ.toLowerCase()), 1),
              _createTextVNode(") ")
            ]),
            _createElementVNode("div", _hoisted_32, [
              (_ctx.selectedCategories.length == 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.language.no_categ_selected), 1))
                : _createCommentVNode("", true),
              _createElementVNode("ul", _hoisted_34, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedCategories, (oSelC) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: oSelC.Code,
                    class: "d-flex my-1 me-1 p-2"
                  }, [
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.getCategoryName(oSelC)), 1),
                    _createElementVNode("span", null, [
                      _createElementVNode("a", {
                        href: "javascript:;",
                        class: "text-danger",
                        title: _ctx.language.remove_category,
                        onClick: ($event: any) => (_ctx.removeSelectedCategory(oSelC))
                      }, _hoisted_38, 8, _hoisted_36)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.v$.dataRecord.Categories.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.v$.dataRecord.Categories.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.SubCategories.$error}])
          }, [
            _createElementVNode("label", _hoisted_40, [
              _createTextVNode(_toDisplayString(_ctx.language.sub_categories) + "  ", 1),
              (_ctx.possibleSubCategories.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                    _createElementVNode("a", _hoisted_42, "(" + _toDisplayString(_ctx.language.add_sub_categ.toLowerCase()) + ")", 1),
                    _createElementVNode("ul", _hoisted_43, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.possibleSubCategories, (oSubCateg) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: oSubCateg.Code + '' + oSubCateg.SubCode
                        }, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:;",
                            onClick: ($event: any) => (_ctx.selectSubCategory(oSubCateg))
                          }, _toDisplayString(_ctx.getSubCategoryName(oSubCateg)), 9, _hoisted_44)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createTextVNode(" ("),
              _createElementVNode("a", {
                href: "javascript:;",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.addSubCategoryElement && _ctx.addSubCategoryElement(...args)))
              }, _toDisplayString(_ctx.language.new_sub_categ.toLowerCase()), 1),
              _createTextVNode(") ")
            ]),
            _createElementVNode("div", _hoisted_45, [
              (_ctx.selectedSubCategories.length == 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.language.no_sub_categ_selected), 1))
                : _createCommentVNode("", true),
              _createElementVNode("ul", _hoisted_47, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSubCategories, (oSelC) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: oSelC.Code + '' + oSelC.SubCode,
                    class: "d-flex my-1 me-1 p-2"
                  }, [
                    _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.getSubCategoryName(oSelC)), 1),
                    _createElementVNode("span", null, [
                      _createElementVNode("a", {
                        href: "javascript:;",
                        class: "text-danger",
                        title: _ctx.language.remove_category,
                        onClick: ($event: any) => (_ctx.removeSelectedSubCategory(oSelC))
                      }, _hoisted_51, 8, _hoisted_49)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            (_ctx.v$.dataRecord.SubCategories.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_ctx.v$.dataRecord.SubCategories.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.BrandCode.$error}])
          }, [
            _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.language.brand), 1),
            _withDirectives(_createElementVNode("select", {
              id: "BrandCode",
              class: "form-control-sel tab-press",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dataRecord.BrandCode) = $event)),
              disabled: _ctx.isSavingRecord
            }, [
              _createElementVNode("option", _hoisted_55, _toDisplayString(_ctx.language.select_brand), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstBrands, (oBrand) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: oBrand.Code,
                  key: oBrand.Code
                }, _toDisplayString(oBrand.BrandName), 9, _hoisted_56))
              }), 128))
            ], 8, _hoisted_54), [
              [_vModelSelect, _ctx.dataRecord.BrandCode]
            ]),
            _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.language.brand_info_msg), 1),
            (_ctx.v$.dataRecord.BrandCode.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_ctx.v$.dataRecord.BrandCode.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.dataRecord.IsKeepStock) = $event)),
                id: "IsKeepStock"
              }, null, 512), [
                [_vModelCheckbox, _ctx.dataRecord.IsKeepStock]
              ]),
              _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.language.track_stock), 1)
            ]),
            _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.language.track_stock_info_msg), 1)
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.dataRecord.IsTaxable) = $event)),
                id: "IsTaxable",
                onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onTaxChanged && _ctx.onTaxChanged(...args)))
              }, null, 544), [
                [_vModelCheckbox, _ctx.dataRecord.IsTaxable]
              ]),
              _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.language.is_taxable), 1)
            ]),
            _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.language.is_taxable_info_msg), 1)
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.dataRecord.AllowPurchaseOutStock) = $event)),
                id: "AllowPurchaseOutStock"
              }, null, 512), [
                [_vModelCheckbox, _ctx.dataRecord.AllowPurchaseOutStock]
              ]),
              _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.language.allow_sales_out_stock), 1)
            ]),
            _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.language.allow_sales_out_stock_info_msg), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.ReorderQuantity.$error}])
          }, [
            _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.language.reorder_quantity), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "ReorderQuantity",
              class: "form-control numeric tab-press text-end",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.dataRecord.ReorderQuantity) = $event)),
              placeholder: '(' + _ctx.language.reorder_quantity.toLowerCase() + ')',
              maxlength: "5",
              autocomplete: "off",
              onFocus: _cache[18] || (_cache[18] = ($event: any) => (_ctx.selectOnFocus($event))),
              disabled: _ctx.isSavingRecord
            }, null, 40, _hoisted_72), [
              [_vModelText, _ctx.dataRecord.ReorderQuantity]
            ]),
            _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.language.reorder_quantity_info_msg), 1),
            (_ctx.v$.dataRecord.ReorderQuantity.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_74, _toDisplayString(_ctx.v$.dataRecord.ReorderQuantity.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.MinOrderQuantity.$error}])
          }, [
            _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.language.minimum_order_qty), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "MinOrderQuantity",
              class: "form-control numeric tab-press text-end",
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.dataRecord.MinOrderQuantity) = $event)),
              placeholder: '(' + _ctx.language.minimum_order_qty.toLowerCase() + ')',
              maxlength: "5",
              autocomplete: "off",
              onFocus: _cache[20] || (_cache[20] = ($event: any) => (_ctx.selectOnFocus($event))),
              disabled: _ctx.isSavingRecord
            }, null, 40, _hoisted_76), [
              [_vModelText, _ctx.dataRecord.MinOrderQuantity]
            ]),
            _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.language.minimum_order_qty_info_msg), 1),
            (_ctx.v$.dataRecord.MinOrderQuantity.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_78, _toDisplayString(_ctx.v$.dataRecord.MinOrderQuantity.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.PurchasePrice.$error}])
          }, [
            _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.language.purchase_price), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "PurchasePrice",
              class: "form-control numeric tab-press text-end",
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.dataRecord.PurchasePrice) = $event)),
              placeholder: '(' + _ctx.language.purchase_price.toLowerCase() + ')',
              maxlength: "20",
              autocomplete: "off",
              onFocus: _cache[22] || (_cache[22] = ($event: any) => (_ctx.selectOnFocus($event))),
              disabled: _ctx.isSavingRecord
            }, null, 40, _hoisted_80), [
              [_vModelText, _ctx.dataRecord.PurchasePrice]
            ]),
            _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.language.purchase_price_info_msg), 1),
            (_ctx.v$.dataRecord.PurchasePrice.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_82, _toDisplayString(_ctx.v$.dataRecord.PurchasePrice.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.SellingPrice.$error}])
          }, [
            _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.language.selling_price), 1),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "SellingPrice",
              class: "form-control numeric tab-press text-end",
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.dataRecord.SellingPrice) = $event)),
              placeholder: '(' + _ctx.language.selling_price.toLowerCase() + ')',
              maxlength: "20",
              autocomplete: "off",
              onFocus: _cache[24] || (_cache[24] = ($event: any) => (_ctx.selectOnFocus($event))),
              disabled: _ctx.isSavingRecord
            }, null, 40, _hoisted_84), [
              [_vModelText, _ctx.dataRecord.SellingPrice]
            ]),
            _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.language.selling_price_info_msg), 1),
            (_ctx.v$.dataRecord.SellingPrice.$error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_86, _toDisplayString(_ctx.v$.dataRecord.SellingPrice.$errors[0].$message), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("label", _hoisted_88, _toDisplayString(_ctx.language.default_supplier), 1),
            _withDirectives(_createElementVNode("select", {
              id: "DefaultSupplier",
              class: "form-control-sel tab-press",
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.dataRecord.DefaultSupplier) = $event)),
              disabled: _ctx.isSavingRecord
            }, [
              _createElementVNode("option", _hoisted_90, _toDisplayString(_ctx.language.select_supplier + ' (' + _ctx.language.none_selected.toLowerCase() + ')'), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstSuppliers, (oSupplier) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: oSupplier.SupplierKey,
                  key: oSupplier.IdSupplier
                }, _toDisplayString(oSupplier.SupplierName), 9, _hoisted_91))
              }), 128))
            ], 8, _hoisted_89), [
              [_vModelSelect, _ctx.dataRecord.DefaultSupplier]
            ]),
            _createElementVNode("div", _hoisted_92, _toDisplayString(_ctx.language.default_supplier_info_msg), 1)
          ]),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.language.default_tax), 1),
            _withDirectives(_createElementVNode("select", {
              id: "DefaultTax",
              class: "form-control-sel tab-press",
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.dataRecord.DefaultTax) = $event)),
              disabled: _ctx.isSavingRecord || !_ctx.dataRecord.IsTaxable
            }, [
              _createElementVNode("option", _hoisted_96, _toDisplayString(_ctx.language.select_tax + ' (' + _ctx.language.none_selected.toLowerCase() + ')'), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstTaxes, (oTax) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: oTax.TaxKey,
                  key: oTax.TaxKey
                }, _toDisplayString(oTax.TaxName), 9, _hoisted_97))
              }), 128))
            ], 8, _hoisted_95), [
              [_vModelSelect, _ctx.dataRecord.DefaultTax]
            ]),
            _createElementVNode("div", _hoisted_98, _toDisplayString(_ctx.language.default_tax_info_msg), 1),
            (!_ctx.isDefaultTaxReqSet)
              ? (_openBlock(), _createElementBlock("div", _hoisted_99, _toDisplayString(_ctx.language.default_tax_msg_error), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_100, [
            _createElementVNode("div", _hoisted_101, [
              _createElementVNode("div", {
                class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.UnitOfMeasuremt.$error}])
              }, [
                _createElementVNode("label", _hoisted_102, _toDisplayString(_ctx.language.uom_sh), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "UnitOfMeasuremt",
                  class: "form-control tab-press",
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.dataRecord.UnitOfMeasuremt) = $event)),
                  placeholder: '(' + _ctx.language.uom_sh.toLowerCase() + ')',
                  maxlength: "50",
                  autocomplete: "off",
                  onFocus: _cache[28] || (_cache[28] = ($event: any) => (_ctx.selectOnFocus($event))),
                  disabled: _ctx.isSavingRecord
                }, null, 40, _hoisted_103), [
                  [_vModelText, _ctx.dataRecord.UnitOfMeasuremt]
                ]),
                _createElementVNode("div", _hoisted_104, _toDisplayString(_ctx.language.uom_info_msg), 1),
                (_ctx.v$.dataRecord.UnitOfMeasuremt.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_105, _toDisplayString(_ctx.v$.dataRecord.UnitOfMeasuremt.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["col-md-6 form-group", {'has-error': _ctx.v$.dataRecord.PcePerUnit.$error}])
              }, [
                _createElementVNode("label", _hoisted_106, _toDisplayString(_ctx.language.pces_per_unit), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "PcePerUnit",
                  class: "form-control tab-press numeric",
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.dataRecord.PcePerUnit) = $event)),
                  placeholder: '(' + _ctx.language.pces_per_unit.toLowerCase() + ')',
                  maxlength: "3",
                  autocomplete: "off",
                  onFocus: _cache[30] || (_cache[30] = ($event: any) => (_ctx.selectOnFocus($event))),
                  disabled: _ctx.isSavingRecord
                }, null, 40, _hoisted_107), [
                  [_vModelText, _ctx.dataRecord.PcePerUnit]
                ]),
                _createElementVNode("div", _hoisted_108, _toDisplayString(_ctx.language.pces_per_unit_msg), 1),
                (_ctx.v$.dataRecord.PcePerUnit.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_109, _toDisplayString(_ctx.v$.dataRecord.PcePerUnit.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_110, [
            _createElementVNode("label", _hoisted_111, _toDisplayString(_ctx.language.tags), 1),
            _createVNode(_component_jw_tag_input_v2, {
              initialTags: _ctx.tags,
              onAfterUpdate: _ctx.updateTags,
              disabled: _ctx.isSavingRecord
            }, null, 8, ["initialTags", "onAfterUpdate", "disabled"]),
            _createElementVNode("div", _hoisted_112, _toDisplayString(_ctx.language.tags_info_details), 1)
          ]),
          _createElementVNode("div", _hoisted_113, [
            _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.language.description), 1),
            _withDirectives(_createElementVNode("textarea", {
              id: "Description",
              class: "form-control tab-press",
              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.dataRecord.Description) = $event)),
              placeholder: '(' + _ctx.language.description.toLowerCase() + ')',
              maxlength: "500",
              autocomplete: "off",
              onFocus: _cache[32] || (_cache[32] = ($event: any) => (_ctx.selectOnFocus($event))),
              disabled: _ctx.isSavingRecord,
              rows: "3"
            }, null, 40, _hoisted_115), [
              [_vModelText, _ctx.dataRecord.Description]
            ]),
            _createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.language.description_prod_info_msg), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_117, [
        _createElementVNode("div", _hoisted_118, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-block",
            disabled: _ctx.v$.$invalid || _ctx.isSavingRecord || !_ctx.isDefaultTaxReqSet,
            onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.saveNewProduct && _ctx.saveNewProduct(...args)))
          }, [
            (_ctx.isSavingRecord)
              ? (_openBlock(), _createElementBlock("span", _hoisted_120, [
                  _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-spinner'] }),
                  _createTextVNode("  ")
                ]))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.language.save), 1)
          ], 8, _hoisted_119)
        ])
      ])
    ], 2),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
      _createVNode(_component_ProdCategoryModal, {
        visible: _ctx.isCategoryVisible,
        initialValues: _ctx.newCategory,
        recordStatus: 0,
        onCloseForm: _ctx.onCloseCategory
      }, null, 8, ["visible", "initialValues", "onCloseForm"]),
      _createVNode(_component_ProdSubCategoryModal, {
        visible: _ctx.isSubCategoryVisible,
        listCategories: _ctx.lstCategories,
        initialValues: _ctx.newCategory,
        recordStatus: 0,
        onCloseForm: _ctx.onCloseSubCategory
      }, null, 8, ["visible", "listCategories", "initialValues", "onCloseForm"])
    ]))
  ], 64))
}